// src/components/LanguageSelector.tsx

import { MenuItem, Select, SelectChangeEvent } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { LanguageCode } from './Language'

interface LanguageSelectorProps {
  languages: LanguageCode[]
  selectedLanguage: LanguageCode
  onLanguageChange: (lang: LanguageCode) => void
}

export function LanguageSelector(props: LanguageSelectorProps) {
  const {languages, selectedLanguage, onLanguageChange} = props
  useTranslation()

  /**
   * Handle the change event and pass the selected LanguageCode to the parent.
   */
  const handleSelectChange = (event: SelectChangeEvent<LanguageCode>) => {
    onLanguageChange(event.target.value as LanguageCode)
  }

  /**
   * Generate display labels for each language code.
   */
  const getLanguageLabel = (lang: LanguageCode): string => {
    switch (lang) {
      case LanguageCode.EN:
        return '🇬🇧 English'
      case LanguageCode.CS:
        return '🇨🇿 Czech'
      case LanguageCode.SK:
        return '🇸🇰 Slovak'
      default:
        return lang
    }
  }

  return (
    <>
      <Select
        labelId="meal-language-label"
        id="meal-language"
        value={selectedLanguage}
        onChange={handleSelectChange}
        size="small"
        sx={{
          minWidth: { xs: 112, sm: 164 },
          mb: 0,
          color: 'inherit',
          backgroundColor: 'rgba(255,255,255,0.12)',
          borderRadius: 999,
          '.MuiOutlinedInput-notchedOutline': {
            borderColor: 'rgba(255,255,255,0.28)',
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: 'rgba(255,255,255,0.42)',
          },
          '& .MuiSvgIcon-root': {
            color: 'inherit',
          }
        }}
      >
        {languages.map((lang) => (
          <MenuItem key={lang} value={lang}>
            {getLanguageLabel(lang)}
          </MenuItem>
        ))}
      </Select>
    </>
  )
}
